import { Component } from '@angular/core';
import { PaymentGateway, User, Notify, RetailMessageService, SessionService, SharedService, MessageService } from 'baseline-lib';
import { CustomToast } from '../../shared/services/custom-toast';

// import { User } from '../../_models/common/user';
// import { MessageService } from '../../_service/message.service';
// import { SessionService } from '../../_service/session.service';
// import { SharedService } from '../../_service/shared.service';
// import { Notify } from '../../_models/common/notify';
// import { PaymentGateway } from '../../_models/retailer/payment-gateway';
// import { RetailMessageService } from '../_services/retail-message.service';

@Component({
  selector: 'retail-remitance',
  templateUrl: 'retail-remitance.html'
})
export class RetailRemitanceComponent {

  paymentGatewayList: PaymentGateway[] = [];
  paymentGatewayObj: PaymentGateway = undefined;
  authUser: User;
  selPaymentGateway: number;

  _showTransDetails: boolean = false;
  hidePayStackButton: boolean = true;

  _notify: Notify;
  userEmail: string = undefined;

  constructor(
    private _retailMessageService: RetailMessageService,
    private _sessionService: SessionService,
    public _sharedService: SharedService,
    private _messageService: MessageService,
    private toast: CustomToast

  ) {

    this.reset();
    this.authUser = this._sessionService.getAuthUser();
    this._notify = new Notify();

    if (this.authUser) {
      if (this.authUser.email)
        this.userEmail = this.authUser.email;

      this._retailMessageService.getPGList(this.authUser.tokenNo).subscribe(
        data => {
          this.paymentGatewayList.push(new PaymentGateway("Select Payment Gateway"));
            data.forEach(element => {
              this.paymentGatewayList.push(element);
            });
        },
        error => {
          this.paymentGatewayList = [];
        }
      );
    }
  }
  reset() {
    this._showTransDetails = false;
    this.hidePayStackButton = true;
    this.selPaymentGateway = undefined;
    this.paymentGatewayObj = new PaymentGateway(null);
  }
  ngOnInit() {
    this.reset();
  }
  pgChange(event) {
    this.selPaymentGateway = event;
    if (event != undefined) {
      var _selPGObj = this.paymentGatewayList.filter(_pg => _pg.companyId == this.selPaymentGateway)[0];
      if (_selPGObj.name.toLowerCase() == 'paystack') {
        this.hidePayStackButton = false;
      }

    }
  }
  payRemitAmt() {
    this._sharedService.showLoader();
    if (this.validateData() && this.authUser) {
      this.paymentGatewayObj = this.paymentGatewayObj.parse(this.paymentGatewayObj, this.paymentGatewayList.filter(_pg => _pg.companyId == this.selPaymentGateway)[0]);
      this.paymentGatewayObj.datetime = new Date();
      let timestamp = new Date().getTime();
      this.paymentGatewayObj.refKey = timestamp.toString();
      this.paymentGatewayObj.tokenNo = this.authUser.tokenNo;

      this._retailMessageService.transactPG(this.paymentGatewayObj).subscribe(
        data => {
          this.paymentGatewayObj.refKey = data.refKey;
          this._sharedService.hideLoader();
          this._showTransDetails = true;

          this._notify.successMsg = data.msg;
          this.toast.showSuccess(this._notify.successMsg);

          setTimeout(() => {
            this._notify.successMsg = '';
          }, 3000);
        },
        error => {

          if (error.msg) {
            this._notify.errorMsg = error.msg;
          }
          else {
            this._notify.errorMsg = "Server Error..";
          }
          this.toast.showError(this._notify.errorMsg);

          this._sharedService.hideLoader();
          setTimeout(() => {
            this._notify.errorMsg = '';
          }, 3000);
        }
      );
    }
    this._sharedService.hideLoader();
  }
  validateData(): boolean {
    this._notify = new Notify();
    if (!this.paymentGatewayObj.amount) {
      this._notify.errorMsg = 'Please enter Amount';
      this.toast.showError(this._notify.errorMsg);

      setTimeout(() => {
        this._notify.errorMsg = "";
      }, 2000);
      return false;
    }
    if (this.paymentGatewayObj.amount <= 0 || this.paymentGatewayObj.amount > this.authUser.endBalance) {
      this._notify.errorMsg = 'Please Check Amount';
      this.toast.showError(this._notify.errorMsg);

      setTimeout(() => {
        this._notify.errorMsg = "";
      }, 2000);
      return false;
    }
    if (!this.userEmail || !this.isEmail(this.userEmail)) {
      this._notify.errorMsg = 'Please enter valid Email';
      this.toast.showError(this._notify.errorMsg);

      setTimeout(() => {
        this._notify.errorMsg = "";
      }, 2000);
      return false;
    }
    if (!this.selPaymentGateway) {
      this._notify.errorMsg = 'Please Select Payment Gateway.';
      this.toast.showError(this._notify.errorMsg);

      setTimeout(() => {
        this._notify.errorMsg = "";
      }, 2000);
      return false;
    }
    return true;
  }
  isEmail(search: string): boolean {
    var emailValid: boolean;
    var regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    emailValid = regexp.test(search);
    return emailValid;
  }
  onClickPayStack(): void {
    this._sharedService.showLoader();
    this.hidePayStackButton = true;
    setTimeout(() => {
      this._sharedService.hideLoader();
    }, 1500);
  }
  back() {
    this.hidePayStackButton = false;
    this._showTransDetails = false;
  }
  paymentCancel() {
    this.hidePayStackButton = false;
  }
  paymentDone(message: any): void {
    this._showTransDetails = false;
    console.log("paystack successful Authorization");
    this.hidePayStackButton = false;
    this._retailMessageService.validatePGTrans(message.reference, this.authUser.tokenNo).subscribe(response => {
      if (response.statusCode == '200') {
        this._notify.successMsg = response.message;
        this.toast.showSuccess(this._notify.successMsg);

        this.reset();
        this.updateBalance();
        setTimeout(() => {
          this._notify.successMsg = "";
        }, 2000);
      } else {
        this._notify.errorMsg = response.message;
        this.toast.showError(this._notify.errorMsg);

        setTimeout(() => {
          this._notify.errorMsg = "";
        }, 2000);
      }
    }, error => {
      if (error.error.msg) {
        this._notify.errorMsg = error.msg;
      }
      else {
        this._notify.errorMsg = "Server Error..";
      }
      this.toast.showError(this._notify.errorMsg);

      this._sharedService.hideLoader();
      setTimeout(() => {
        this._notify.errorMsg = '';
      }, 3000);
    });
    this._sharedService.hideLoader();
  }
  updateBalance() {
    if (this.authUser) {
      var token = this.authUser.tokenNo;
      this._messageService.getPlayerBalance(token).subscribe(
        res => {
          this._sharedService.updateUserBalance(res.bal, res.ebal);
          this.authUser = this._sessionService.getAuthUser();
        }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/retailer/retail-remitance/retail-remitance.ts